export enum VendorSource {
    Madar = 'MADAR',
    TGA = 'TGA',
}